import axios from 'axios';

const base_url = import.meta.env.VITE_API_URL;

export function useRememberUser() {
  const saveRememberUser = async (userData) => {
    try {
      const response = await axios.post(`${base_url}/rememberuser`, userData);
      console.log(response.data);
    } catch (error) {
      console.error('Error saving remember user:', error);
    }
  };

  const getRememberUser = async (identification_number) => {
    try {
      const response = await axios.get(`${base_url}/rememberuser/${identification_number}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error(error.response.data);
      }
      return null;
    }
  };

  return {
    saveRememberUser,
    getRememberUser,
  };
}
